import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import messages from 'components/MyContractInfo/AUTOContractInfo/messages';
import {
  StyledCaption,
  StyledPaper,
  StyledShortBody,
} from 'components/MyContractInfo/styles';
import StatusChip from 'components/StatusChip';
import { SmallSectionHeader } from 'components/Typography';
import { get } from 'lodash';
import React, { ReactNode } from 'react';
import { injectIntl, IntlShape, useIntl } from 'react-intl';

interface ContractItemProps {
  label: string;
  value: string | ReactNode;
}
const ContractItem = ({ value, label }: ContractItemProps) => {
  const { formatMessage } = useIntl();

  return (
    <Grid item sm={6} md={3}>
      <Grid container direction="column">
        <Grid item>
          <StyledCaption>{formatMessage(get(messages, label))}</StyledCaption>
        </Grid>
        <Grid item>
          <Box marginBottom={2}>
            {typeof value === 'string' ? (
              <StyledShortBody>{value}</StyledShortBody>
            ) : (
              value
            )}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export interface AUTOContractInfoType {
  intl: IntlShape;
  numPolice: string;
  dateEffet: string;
  dateEcheance: string;
  immatriculation: string;
  produit: string;
  tarif: string;
  status: string;
  statusLabel: string;
}
const AUTOContractInfo = (props: AUTOContractInfoType) => {
  const {
    numPolice,
    dateEffet,
    dateEcheance,
    immatriculation,
    produit,
    tarif,
    status,
    statusLabel,
  } = props;

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const parentDirection = matches ? 'row' : 'column';
  const childDirection = matches ? 'column' : 'row';

  return (
    <StyledPaper>
      <Box padding={2}>
        <Grid container justify="space-between" direction={parentDirection}>
          <Grid item xs={6} sm={12}>
            <Grid container direction={childDirection}>
              <ContractItem label="numPolice" value={numPolice} />
              <ContractItem label="dateEffet" value={dateEffet} />
              <ContractItem label="immatriculation" value={immatriculation} />
              <ContractItem label="produit" value={produit} />
            </Grid>
          </Grid>
          <Grid item xs={6} sm={12}>
            <Grid container direction={childDirection}>
              <ContractItem
                label="status"
                value={<StatusChip status={status} label={statusLabel} />}
              />
              <ContractItem label="dateEcheance" value={dateEcheance} />
              <ContractItem
                label="tarif"
                value={
                  <SmallSectionHeader color="#6FAD37">
                    {tarif}
                  </SmallSectionHeader>
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </StyledPaper>
  );
};

export default injectIntl(AUTOContractInfo);
